import { PATH } from '../../../../../const'
import { COPY } from '../constants'
import { Link } from '../link'

export const GoHome = () => (
  <Link to={PATH.home} variant="button">
    {COPY.goHome}
  </Link>
)
